/** Returns a string with valid classes only */
export const mergeClassNames = (
  ...classes: (string | null | undefined | false)[]
) => [...classes].filter(Boolean).join(" ");
